var _rect, _rect2, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 17.998,
    height: 17.998,
    rx: 8.99902,
    fill: "#FFE4E4"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 16,
    height: 16,
    rx: 8,
    fill: "#D43939"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5356 5.46438C11.5912 4.52 10.3356 4 9 4C7.66437 4 6.40875 4.52 5.46438 5.46438C4.52 6.40875 4 7.66437 4 9C4 10.3356 4.52 11.5912 5.46438 12.5356C6.40875 13.48 7.66437 14 9 14C10.3356 14 11.5912 13.48 12.5356 12.5356C13.48 11.5912 14 10.3356 14 9C14 7.66437 13.48 6.40875 12.5356 5.46438ZM12.75 9C12.7508 9.77868 12.508 10.5381 12.0556 11.1719L6.82812 5.94438C7.46189 5.49196 8.22132 5.24916 9 5.25C11.0675 5.25 12.75 6.9325 12.75 9ZM5.25 9C5.24916 8.22132 5.49196 7.46189 5.94438 6.82812L11.1719 12.0556C10.5381 12.508 9.77868 12.7508 9 12.75C6.9325 12.75 5.25 11.0675 5.25 9Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlocked);
export default __webpack_public_path__ + "static/media/blocked.f522c5abe523d2f62c8b92c273e46ca3.svg";
export { ForwardRef as ReactComponent };